import { Component } from '@angular/core';
import { Conversation } from '../../../models/chat/chatModel';
import { ChatService } from '../../../models/chat/chatService';
import { TableViewAbstractComponent } from '../../ui/filterable-table/tableViewAbstractComponent';

@Component({
  selector: 'app-chat-center-table-view',
  templateUrl: './chat-center-table-view.component.html',
  standalone: false,
})
export class ChatCenterTableViewComponent extends TableViewAbstractComponent {
  constructor(public chat: ChatService) {
    super();
  }

  getPageOfData(
    query: string,
    filters: any[],
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ) {
    return this.chat.getQueue(pageNum, pageSize);
  }

  // TODO (jacob):
  canQuery(): boolean {
    return true;
  }

  // TODO (jacob):
  getRecordFromDataSource(conversationId: string): Conversation {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == conversationId) {
        return this.dataSource.data[i];
      }
    }

    throw 'Conversation not found in dataset';
  }

  _selectRow_click(id: string) {
    if (this.options.selectAction != 'none') {
      this.selectRow_click(id);
    }
  }
}
